import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ts-posts',
  templateUrl: './ts-posts.component.html',
  styleUrls: ['./ts-posts.component.scss']
})
export class TsPostsComponent {
  @Input() data: any;
}
